<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>

<alert-confirmar-pedido [showAlertConfirmaPedido]="showAlertConfirmaPedido" (confirmarPedido)="onSubmit($event)">
</alert-confirmar-pedido>
<app-alert-sucesso [alertSucesso]="alertSucesso" [alertSucessoMensagem]="alertSucessoMensagem"
[alertSucessoSubtitulo]="alertSucessoSubtitulo" (alertSucessoFechou)="eventoAlertSucessoFechou($event)"></app-alert-sucesso>
<app-alert-erro-customizado [alertErro]="showAlertErro" [alertErroBotao]="mensagemErroApiBotao" [alertErroTitulo]="mensagemErroApiTitulo" [alertErroMensagem]="mensagemErroApi" (alertErroFechou)="eventoAlertErro($event)"></app-alert-erro-customizado>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Fazer Pedido Avulso</h1>
        <p class="paragrafo mb-4">Pedido personalizado por usuário</p>

        <div class="row">
          <div class="col-lg-3">
            <span class="paragrafo"> Total de Produtos </span>
            <p class="label">{{$safeNavigationMigration(valoresSalvos?.totalProdutos) | currency: 'BRL' }} </p>
          </div>

          <div class="col-lg-3">
            <span class="paragrafo"> Total de Taxa </span>
            <p class="label">{{$safeNavigationMigration(valoresSalvos?.totalTaxas) | currency: 'BRL' }} </p>
          </div>

          <div class="col-lg-3">
            <span class="paragrafo"> Total do Pedido </span>
            <p class="label">{{$safeNavigationMigration(valoresSalvos?.totalPedido) | currency: 'BRL' }}</p>
          </div>
        </div>

        <p class="label mt-3"> PROCURAR USUÁRIO</p>

        <div class="row">
          <div class="col-lg-7">
            <input type="text" class="form-control" [(ngModel)]="searchTextFilter" (click)="openFilter()" (clickOutside)="closeSearchText($event)" (ngModelChange)="formatSearchText()">
            @if (searchTextFilterUsers && usuarios.length > 0) {
              <ul class="list-group menu lista-usuarios">
                @for (usuario of usuarios | filter: searchTextFilterFormatted; track usuario) {
                  <li class="list-group-item" style="width: 600px;">
                    <button
                      class="btn border-0 bg-transparent text-start ms-4 lg-7"
                      style="width: 600px"
                      (click)="closeSearchTextFilter(usuario)"
                      [attr.aria-label]="'Selecionar usuário ' + usuario.nomeUsuario">>
                      {{ usuario.nomeUsuario }} - {{ usuario.codigoUsuario }} - {{ usuario.codigoCpf | cpf }}
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
          <div class="col-lg-1">
            <button type="button" class="botao-secundario text-center" [disabled]="!usuarioSelecionado" (click)="addUsers()">INCLUIR</button>
          </div>
        </div>



        <table class="table table-hover border-bottom mt-4" aria-describedby="tabela que lista os usuarios">
          <thead>
            <tr>
              <th scope="col">MATRICULA</th>
              <th scope="col">USUÁRIO</th>
              <th scope="col">CPF</th>
              <th scope="col">DEPARTAMENTO</th>
              <th scope="col">VALOR BENEFÍCIOS</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>

            @for (usuariosAdicionados of usuarioSalvo ; track usuariosAdicionados) {
              <tr>
                <td class="text-nowrap"> {{usuariosAdicionados.matricula}}  </td>
                <td>  {{usuariosAdicionados.nome}} </td>
                <td> {{usuariosAdicionados.cpf | cpf}}  </td>
                <td> {{usuariosAdicionados.departamento}}  </td>
                <td> {{usuariosAdicionados.valorBeneficio | currency: 'BRL'}}  </td>
                <td class="text-center">
                  <button
                    class="btn p-0 border-0 bg-transparent"
                    (click)="clickExclude(usuariosAdicionados)"
                    aria-label="Excluir usuário">
                    <i class="fa fa-trash c-primary icone-menor" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>


        <div class="row">
          @if (enderecoSalvo) {
            <div class="col-lg-12">
              <p class="label mt-3"> ENDERECO DE FATURAMENTO</p>
              <app-select
                [value]="enderecoFaturamento"
                name="enderecoFaturamento"
                (change)="onEnderecoSelecionado($event.target.value)"
                [ngClass]="{ 'is-invalid': enderecoFaturamentoError }"
                [options]="enderecoSalvoOptions"
                defaultDescription="SELECIONE"
                defaultValue="SELECIONE"
                optionValue="value"
                optionText="description">
              </app-select>
              <field-error [isError]="enderecoFaturamentoError" message="Endereço de faturamento obrigatório"></field-error>
            </div>
          }
          @if (!enderecoSalvo && !buscandoEnderecos) {
            <div class="col-lg-10">
              <p class="legenda-erro">Erro ao consultar endereços.</p>
            </div>
          }
        </div>


        <app-pedido-form-fields [form]="this"></app-pedido-form-fields>


        <div class="container">
          <div class="row">
            <div class="col text-center">
              <button type="button" class="botao-outline me-3 px-5" (click)="goBackPage()">CANCELAR PEDIDO</button>
              <button type="button" class="botao-outline me-3 px-5" [disabled]="calculado === true" (click)="calcularPedido(true)">RECALCULAR PEDIDO</button>
              <button type="button" [disabled]="calculado === false"  class="botaoLongo text-center mt-3" (click)="onConcluirPedido()" [ngClass]="{ 'disabled': calculado === false}">CONCLUIR SOLICITAÇÃO DE PEDIDO </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
@if (showTentarNovamente === true) {
  <div class="body-alert-modal">
    <div class="div-alert text-center" style="width: 559px;height: 360px">
      <div class="row" style="position: absolute;right: 40px;top: 15px;">
        <button
          class="btn p-0 border-0 bg-transparent"
          (click)="fecharTentarNovamente()"
          aria-label="Fechar">
          <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
        </button>
      </div>
      <div class="div-alert-erro-padrao">
        <img src="/assets/img/alerta-padrao.png" alt="Representando alerta" width="90px">
        <h1>Ops, algo deu errado :(</h1>
        <p>{{descricaoTentarNovamente}}</p>
        <button class="botao-alert-erro" (click)="calcularPedido(true)" id="fechaAlertaErro">TENTAR NOVAMENTE</button>
      </div>
    </div>
  </div>
}
@if (showUsuariosRemovidos === true) {
  <div class="body-alert-modal">
    <div class="div-alert text-center" style="width: 540px;height: 280px">
      <div class="div-botao-fechar">
        <button
          class="btn p-0 border-0 bg-transparent"
          (click)="fechaUsuariosRemovidos()"
          aria-label="Fechar">
          <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
        </button>
      </div>
      <div class="div-alert-sucesso-padrao">
        <img src="/assets/img/alerta-padrao.png" alt="Representando erro" width="90px" style="padding-top: 20px;">
        <h1 style="margin-top: 10px;">Atenção!</h1>
      </div>
      <div class="descricao-usuarios-removidos">
        <p>{{descricaoUsuariosRemovidos}}</p>
        <button (click)="fechaUsuariosRemovidos()" id="fechar">FECHAR</button>
      </div>
    </div>
  </div>
}

<app-footer></app-footer>
